import React from "react";
import { AdvancedUserAnalytics as AdvancedUserAnalyticsComponent } from "@/components/AdvancedUserAnalytics";

export default function AdvancedUserAnalytics() {
  return <AdvancedUserAnalyticsComponent />;
}
